import React from "react";
import PlanDetailList from "./PlanDetailList";
import { Plan, PlanDetailsSection } from "../@types";
import { useTranslate } from "../helpers";
import { addProtocolToUrl } from "../helpers/objectUtilities";

interface PlanContactProps {
  plan: Plan;
}

const PlanContact: React.FunctionComponent<PlanContactProps> = ({ plan }) => {
  const memberPhone = plan.member_phone && plan.member_phone.number;
  const nonMemberPhone = plan.prospect_phone && plan.prospect_phone.number;

  const t = useTranslate();

  return (
    <PlanDetailList
      id={PlanDetailsSection.CONTACT_INFO}
      title={t("plan_terms.contact_information")}
    >
      <div className="PlanContact">
        <div className="ds-l-col--12 ds-l-md-col--3 ds-u-margin-bottom--2 ds-u-sm-margin-bottom--0">
          <a
            href={addProtocolToUrl(plan.url)}
            target="_blank"
            rel="noopener noreferrer"
            className="preview-disable-exempt"
          >
            {t("plan_terms.view_plan_website")}
          </a>
        </div>
        <div className="ds-l-col--12 ds-l-md-col--3 ds-u-margin-bottom--2 ds-u-sm-margin-bottom--0">
          <address className="ds-u-font-style--normal">
            {plan.address_1}
            <br />
            {plan.address_2 && (
              <>
                {plan.address_2}
                <br />
              </>
            )}
            {plan.city}, {plan.state} {plan.zipcode}
          </address>
        </div>
        <div className="ds-l-col--12 ds-l-md-col--3 ds-u-margin-bottom--2 ds-u-sm-margin-bottom--0">
          <a href={`tel:${memberPhone}`}>{memberPhone}</a>
          <br />
          <strong>{t("plan_terms.members")}</strong>
        </div>
        <div className="ds-l-col--12 ds-l-md-col--3 ds-u-margin-bottom--2 ds-u-sm-margin-bottom--0">
          <a href={`tel:${nonMemberPhone}`}>{nonMemberPhone}</a>
          <br />
          <strong>{t("plan_terms.non_members")}</strong>
        </div>
      </div>
    </PlanDetailList>
  );
};

export default PlanContact;
